import { AdvertQuery, PagingDictionary } from '../models/advertQuery.model';
import { EAdvertSortOrder } from '../datatypes/misc';

export class AdvertQueryHelper {


    // the negation of distSpecified is not used anywhere since it doesn't differentiate
    // between clauses; also the distance is set automatically to the default distance (10 miles)
    public static setSortOrder(advertQuery: AdvertQuery) {

        const distSpecified = advertQuery.LocationPlaceData.DistanceInMiles > 0;
        const locValid = advertQuery.LocationPlaceData.PlaceResultMetaData.IsValidLocation;
        const kwSpecified = (advertQuery.KeywordParams.trim() !== '');

        // clause 1: no kw, location or distance (distance irrelevant in clause)
        if (!kwSpecified && !locValid) {
            advertQuery.AdvertSortOrder = EAdvertSortOrder.PublishDate;
            return;
        }

        // clause 2: distance irrelevant
        if (kwSpecified && !locValid) {
            advertQuery.AdvertSortOrder = EAdvertSortOrder.Score;
            return;
        }

        if (!kwSpecified && locValid) {
            advertQuery.AdvertSortOrder = EAdvertSortOrder.GeoDistance;
            return;
        }

        if (kwSpecified && locValid && distSpecified) {
            advertQuery.AdvertSortOrder = EAdvertSortOrder.Score;
            return;
        }
    }

    public static getNewPagingDictionary(): PagingDictionary {
        const pd = new PagingDictionary();
        const map = new Map();
        map.set('1', '*');
        pd.Dictionary = map;
        return pd;
    }
}
